
// src/utils/loadVerbsCsv.js
import Papa from 'papaparse';

// מקבל כותרות באנגלית או בעברית:
// lemma3ms,root,binyan,tense,personHeb,gizra,fa_vowel_past,fa_vowel_future
// או: פועל,שורש,בניין,זמן,גוף,gizra,R2_PAST,R2_FUTURE
export async function loadVerbsCsv(path) {
  const res = await fetch(path);
  const text = await res.text();

  return new Promise((resolve, reject) => {
    Papa.parse(text, {
      header: true,
      skipEmptyLines: true,
      quoteChar: '"',  // מזהה strings בתוך גרשיים
      escapeChar: '"', // escape character לגרשיים כפולים
      complete: ({ data }) => {
        const rows = (data || []).map(r => ({
          // תומך בכותרות אנגלית (lemma3ms) או עברית (פועל)
          'פועל'     : (r['פועל'] || r['lemma3ms'] || '').trim(),
          'שורש'     : (r['שורש'] || r['root'] || '').trim(),
          'בניין'    : (r['בניין'] || r['binyan'] || '').trim(),
          'זמן'      : (r['זמן'] || r['tense'] || '').trim(),
          'גוף'      : (r['גוף'] || r['personHeb'] || '').trim(),
          'gizra'    : (r['gizra'] || r['gzira'] || r['גזרה'] || '').trim(),
          'R2_PAST'  : (r['R2_PAST'] || r['fa_vowel_past'] || '').trim(),
          'R2_FUTURE': (r['R2_FUTURE'] || r['fa_vowel_future'] || '').trim(),
          'allowed_pronouns': (r['allowed_pronouns'] || '').trim(),
          'benoni_poel_allowed': (r['benoni_poel_allowed'] || '').trim(),
          'benoni_paul_allowed': (r['benoni_paul_allowed'] || '').trim(),
          'makor1': (r['makor1'] || '').trim(),
          'makor2': (r['makor2'] || '').trim(),
          'translation1': (r['translation1_he_past'] || r['translation1'] || '').trim(),
          'translation2': (r['translation2_he_past'] || r['translation2'] || '').trim(),
          'lemma3ms': (r['lemma3ms'] || r['פועל'] || '').trim(),
        })).filter(r => r['פועל']); // מסננים שורות ריקות
        resolve(rows);
      },
      error: reject,
    });
  });
}
